import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import DiySolarParts from "./Pages/DiySolarParts";
import DIYSolarResources from "./Pages/DIYSolarResources";
import ContactSection from "./Pages/ContactSection";
import AboutMeSection from "./Pages/AboutMeSection";
import DisclaimerSection from "./Pages/DisclaimerSection";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import AffiliateDisclaimer from "./Pages/AffiliateDisclaimer";
import ShopSection from "./Pages/ShopSection";
import BlogSection from "./Pages/BlogSection";
import BlogLayout from "./Pages/BlogLayout";
import BlogLayout3 from "./Pages/BlogLayout3";
import InstallationPage from "./Pages/InstallationPage";
import LearnFromUs from "./Pages/LearnFromUs";
import ThankYou from "./Pages/ThankYou";
import CaseStudyPage from "./Pages/CaseStudyPage";
import Test from "../src/Pages/test";
import Admin from "../src/Pages/Admin";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/admin" element={<Admin />} />
      <Route path="/diysolarparts" element={<DiySolarParts />} />
      <Route path="/test" element={<Test />} />
      <Route path="/diysolarresources" element={<DIYSolarResources />} />
      <Route path="/home" element={<Home />} />
      <Route path="/contactsection" element={<ContactSection />} />
      <Route path="/aboutmesection" element={<AboutMeSection />} />
      <Route path="/disclaimersection" element={<DisclaimerSection />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/affiliatedisclaimer" element={<AffiliateDisclaimer />} />
      <Route path="/shopsection" element={<ShopSection />} />
      <Route path="/blogsection" element={<BlogSection />} />
      <Route path="/bloglayout" element={<BlogLayout />} />
      <Route path="/bloglayout3" element={<BlogLayout3 />} />
      <Route path="/installationpage" element={<InstallationPage />} />
      <Route path="/learnfromus" element={<LearnFromUs />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route
        path="/case-study/lagos-installation"
        element={<CaseStudyPage />}
      />
    </Routes>
  );
};

export default App;
